module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_e_food.fc42d148.png";